import { EditCustMenuBaseComponent } from './edit-custmenubase/edit-custmenubase.component';
import { AddCustMenuBaseComponent } from './add-custmenubase/add-custmenubase.component';
import { Routes, RouterModule } from '@angular/router';
import { ModuleWithProviders } from '@angular/core';
import { ListCustMenuBaseComponent } from './list-custmenubase/list-custmenubase.component';

export const routesCustMenuBase: Routes = [
    { path: 'page-custmenubase', component: ListCustMenuBaseComponent },
    { path: 'page-custmenubase/add', component: AddCustMenuBaseComponent },
    { path: 'page-custmenubase/:id/edit', component: EditCustMenuBaseComponent },
];

export const CustMenuBaseRoutes: ModuleWithProviders = RouterModule.forChild(routesCustMenuBase);
